import { onBeforeMount } from 'vue'
import router from '@/router'

export function makeABackendCall({
    promise,
    parameters,
    loading,
    confirmMessage,
    alertMessage,
    redirect,
}: {
    promise: any
    parameters?: object
    loading: Boolean
    confirmMessage?: string
    alertMessage?: string
    redirect?: string
}) {
    //we execute the promise only if there's no confirm message(meaning no need to confirm)
    //or if the popup gets confirmed
    if (!confirmMessage || confirm(confirmMessage)) {
        promise(parameters)
        if (redirect) {
            router.push(redirect)
        }
    } else {
        alert(alertMessage)
    }
}

//TODO
// function to convert string (the one taken from path) to number
